import React from 'react';
import { Link } from 'react-router-dom';
import '../OtherVideos/other.css';

function Steam() {
  return (
    <div className="charlie-page">
      <h1 className="charlie-title">📜 Ancient Wisdom & PASSION Dimensions</h1>

      <div className="charlie-table-container">
        <table className="charlie-table">
          <thead>
            <tr>
              <th>Sage / Text</th>
              <th>Dimension(s)</th>
              <th>Modern Interpretation</th>
              <th>View Clip</th>
            </tr>
          </thead>
          <tbody>
            {steamData.map((item, index) => (
              <tr key={index}>
                <td>{item.scene}</td>
                <td>{item.themes}</td>
                <td>{item.interpretation}</td>
                <td>
                  <iframe
                    className="charlie-iframe"
                    src={item.video}
                    title={item.scene}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/zones" className="back-button">
          ⬅ Back to Museum Realms
        </Link>
      </div>
    </div>
  );
}

const steamData = [
  {
    scene: "Kanāda – Atomic Theory in Vaiśeṣika Sūtra",
    themes: "Probing, Innovating, Scoping",
    interpretation: "Early concept of indivisible particles—precursor to modern atomic theory",
    video: "https://www.youtube-nocookie.com/embed/6xcLE6TZBP8?rel=0&modestbranding=1"
  },
  {
    scene: "Patañjali – Systematized Yoga & Prāṇa Control",
    themes: "Nurturing, Peace, Longevity",
    interpretation: "Mind–body wellness, stress relief techniques",
    video: "https://www.youtube-nocookie.com/embed/VM1CZIERVes?rel=0&modestbranding=1"
  },
  {
    scene: "Āryabhaṭa – Earth’s Rotation, Value of π, Heliocentrism",
    themes: "Probing, Scoping, Innovating",
    interpretation: "Foundation of astronomy and mathematics",
    video: "https://www.youtube-nocookie.com/embed/DDEbbafLIY0?rel=0&modestbranding=1"
  },
  {
    scene: "Varāhamihira – Astronomy, Meteorology, Gravity",
    themes: "Probing, Acting, Scoping",
    interpretation: "Early weather science and planetary understanding",
    video: "https://www.youtube-nocookie.com/embed/FDo8t4-KQaI?rel=0&modestbranding=1"
  },
  {
    scene: "Brahmagupta – Zero, Arithmetic, Negative Numbers",
    themes: "Innovating, Probing",
    interpretation: "Key advances in number systems and algebra",
    video: "https://www.youtube-nocookie.com/embed/k1bly3U9r8Y?rel=0&modestbranding=1"
  },
  {
    scene: "Bhāskara I & II – Algebra, Trigonometry",
    themes: "Innovating, Acting, Scoping",
    interpretation: "Built on earlier mathematical foundations",
    video: "https://www.youtube-nocookie.com/embed/kEmQKXwzSak?rel=0&modestbranding=1"
  },
  {
    scene: "Bāudhāyana – Pythagorean Theorem",
    themes: "Probing, Scoping, Innovating",
    interpretation: "Ancient geometry predating Greek contributions",
    video: "https://www.youtube-nocookie.com/embed/n_3cG9oeuNo?rel=0&modestbranding=1"
  },
  {
    scene: "Suśruta – Plastic Surgery & Cataract Extraction",
    themes: "Acting, Protector, Positive Utility",
    interpretation: "Surgical techniques foundational to modern medicine",
    video: "https://www.youtube-nocookie.com/embed/TQpjz_Plf8E?rel=0&modestbranding=1"
  },
  {
    scene: "Caraka – Ayurveda & Pharmacology",
    themes: "Nurturing, Peace, Positive Utility",
    interpretation: "Holistic health system—diet, herbs, and prevention",
    video: "https://www.youtube-nocookie.com/embed/So4byMgO03Q?rel=0&modestbranding=1"
  },
  {
    scene: "Nāgārjuna – Metallurgy & Purification Processes",
    themes: "Innovating, Acting, Tangibility",
    interpretation: "Early chemical and material refining techniques",
    video: "https://www.youtube-nocookie.com/embed/t_Ge-kXhGBM?rel=0&modestbranding=1"
  },
  {
    scene: "Kerala School – Proto-Calculus & Infinite Series",
    themes: "Innovating, Scoping, Probing",
    interpretation: "Foundations of modern calculus",
    video: "https://www.youtube-nocookie.com/embed/fRhO-y9NgjI?rel=0&modestbranding=1"
  },
  {
    scene: "Surya Siddhānta – Trigonometry & Orbital Mechanics",
    themes: "Innovating, Scoping",
    interpretation: "Advanced positional astronomy",
    video: "https://www.youtube-nocookie.com/embed/jOhpr5K0Qng?rel=0&modestbranding=1"
  }
];

export default Steam;
